import { STUDENT_JOURNEY } from "@/data/staticContent";
import { motion } from "framer-motion";
import { ChevronRight } from "lucide-react";

function stepClass(index, total) {
  if (index === 0) return "bg-blue-600 text-white";
  if (index === total - 1) return "bg-emerald-600 text-white";
  return "bg-white border border-slate-200 text-slate-700";
}

export default function StudentJourneyStrip() {
  return (
    <div className="overflow-x-auto -mx-5 lg:mx-0" data-testid="student-journey-strip">
      <div className="min-w-max flex items-center gap-2 px-5 lg:px-0">
        {STUDENT_JOURNEY.map((step, i) => (
          <div key={step} className="flex items-center gap-2">
            <motion.div
              initial={{ opacity: 0, y: 12 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: i * 0.05 }}
              className={`px-4 py-3 rounded-2xl text-sm font-semibold whitespace-nowrap ${stepClass(i, STUDENT_JOURNEY.length)} shadow-sm`}
            >
              {step}
            </motion.div>
            {i < STUDENT_JOURNEY.length - 1 && (
              <ChevronRight className="w-4 h-4 text-slate-300 shrink-0" />
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
